import './featuredInfo.css';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';

export default function FeaturidInfo() {
    return (
        <div className='featured'>
            <div className="featuredItem">
                <span className="featuredTitle">Revanue</span>
                <div className="featuredMoneyContainer">
                    <span className="featuredMoney">$2,415</span>
                    <span className="featuredMoneyRate">-11.4 <ArrowDownward className="featuredIcon negative" /></span>
                </div>
                <div className="featuredSub">Compared to last Month </div>
            </div>
            <div className="featuredItem">
                <span className="featuredTitle">Sales</span>
                <div className="featuredMoneyContainer">
                    <span className="featuredMoney">$4,415</span>
                    <span className="featuredMoneyRate">-1.4 <ArrowDownward className="featuredIcon negative" /></span>
                </div>
                <div className="featuredSub">Compared to last Month </div>
            </div>
            <div className="featuredItem">
                <span className="featuredTitle">cost</span>
                <div className="featuredMoneyContainer">
                    <span className="featuredMoney">$2,225</span>
                    <span className="featuredMoneyRate">-11.4 <ArrowUpward className="featuredIcon" /></span>
                </div>
                <div className="featuredSub">Compared to last Month </div>
            </div>
            <div className="featuredItem">
                <span className="featuredTitle">cost</span>
                <div className="featuredMoneyContainer">
                    <span className="featuredMoney">$2,225</span>
                    <span className="featuredMoneyRate">-11.4 <ArrowUpward className="featuredIcon" /></span>
                </div>
                <div className="featuredSub">Compared to last Month </div>
            </div>
        </div>
    )
}
